import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBack from "../../img/svg/arrow_back_blue.svg";
import ArrowBackWow from "../../img/svg/arrow_back_wow.svg";
import { isPartnerClalit } from "../../store/partnerStore";
import { useSelector } from "react-redux";

const HeaderIconBack = () => {
  const navigate = useNavigate();
  const isClalit = useSelector(isPartnerClalit);
  return (
    <div className={`header-flex`}>
      <img
        src={isClalit ? ArrowBack : ArrowBackWow}
        alt="back"
        onClick={() => {
          if (
            (window.location.pathname === "/card-details" &&
              localStorage.getItem("isHaveUserCreditCard") === "false") ||
            window.location.pathname === "/addCard"
          ) {
            navigate("/");
          } else {
            navigate(-1);
          }
        }}
      />
    </div>
  );
};

export default HeaderIconBack;
